import React from 'react';
import { useSelector } from 'react-redux';
import { RootState as C_RootState } from '@Redux/common/store';
import { RootState } from '@Redux/detail/store';
import cN from 'classnames';
import styles from './styles.module.scss';
import { Divider } from '@lion-design/core';
interface I_Props {
    texts: {
        main: string;
        sub: string;
    };
}

const SubTitle: React.FC<I_Props> = ({ texts }) => {
    const { curPage } = useSelector((store: C_RootState) => store.pageReducer);
    return (
        <div className={styles.container}>
            <Divider
                word={texts.main}
                vertical={false}
                font={20}
                className={cN(styles.main, { [`${styles.printMode}`]: curPage === 'print' })}
            />
            <div className={styles.sub}>{texts.sub}</div>
        </div>
    );
};

export default SubTitle;
